import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

//app components
import PasswordForgetForm from 'components/PasswordForgetForm';
import {
  ROUTE_HOME,
  ROUTE_LOG_IN,
  ROUTE_PASSWORD_FORGET,
  ROUTE_ACCOUNT,
  ROUTE_PASSWORD_RESET,
  ROUTE_PRINCIPLE_SPIRIT,
  ROUTE_PRINCIPLE_MINDSET,
  ROUTE_PRINCIPLE_NUTRITION,
  ROUTE_PRINCIPLE_EXERCISE,
  ROUTE_SIGN_UP,
  ROUTE_GOAL_SETTING,
  ROUTE_TEST,
  ROUTE_ADMIN,
  ROUTE_PLANS
} from 'routes/routes';
import Account from 'views/Account';
import PasswordResetForm from 'PasswordResetForm';
import authComponentSwitch from 'components/Session/authComponentSwitch';
import HomeMembers from 'views/Members';
import Landing from 'views/Landing';
import Spirit from 'views/Principles/Spirit';
import Mindset from 'views/Principles/Mindset';
import Exercise from 'views/Principles/Exercise';
import Nutrition from 'views/Principles/Nutrition';
import SignUp from 'views/SignUp';
import Login from 'views/Login';
import GoalSetting from 'views/GoalSetting';
import TestView from 'views/TestView';
import Dashboard from 'views/Admin/';
import Plans from 'views/Admin/plans';
import withAuthorization from 'components/Session/withAuthorization'
const Routes = () => {
  return (
    <Switch>
      <Route exact path={ROUTE_HOME} component={authComponentSwitch(Landing, HomeMembers)} />
      <Route exact path={ROUTE_PRINCIPLE_SPIRIT} component={Spirit} />
      <Route exact path={ROUTE_PRINCIPLE_MINDSET} component={Mindset} />
      <Route exact path={ROUTE_PRINCIPLE_EXERCISE} component={Exercise} />
      <Route exact path={ROUTE_PRINCIPLE_NUTRITION} component={Nutrition} />
      <Route exact path={ROUTE_GOAL_SETTING} component={GoalSetting} />
      <Route path={ROUTE_LOG_IN} component={Login} />
      <Route path={ROUTE_SIGN_UP} component={SignUp} />
      <Route path={ROUTE_ACCOUNT} component={Account} />
      <Route path={ROUTE_PASSWORD_RESET} component={PasswordResetForm} />
      <Route path={ROUTE_PASSWORD_FORGET} component={PasswordForgetForm} />
      <Route path={ROUTE_TEST} component={TestView} />
      <Route path={ROUTE_ADMIN} component={Dashboard} />
      <Route path={ROUTE_PLANS} component={Plans} />
      <Route path="*" component={() => <Redirect to={ROUTE_HOME} />} />
    </Switch>
  );
};

export default Routes;
